import { Paper } from '@snowball-tech/fractal/dist/src/components/Paper'

import type { ChildrenProps } from '../types'

export default function PaperBlock({ children }: ChildrenProps) {
  return (
    <Paper
      className="flex w-full max-w-screen-sm flex-col items-center gap-5 overflow-y-auto overflow-x-hidden p-3 h-xl:max-h-full h-xl:gap-4 h-md:gap-3"
      elevation="3"
    >
      {children}
    </Paper>
  )
}
